import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { Center, Spinner } from '@/components/ui'
import { TrialDetailPage } from '@/pages/TrialDetailPage'

const trialDetailPageSearchSchema = z.object({
  inquiry: z.string().optional(),
})

export const Route = createFileRoute(
  '/_authenticated/_with-global-layout/trials/$trialNumber/',
)({
  component: RouteComponent,
  validateSearch: search => trialDetailPageSearchSchema.parse(search),
  pendingComponent: () => {
    return (
      <Center h="svh" w="svw">
        <Spinner />
      </Center>
    )
  },
})

function RouteComponent() {
  const { trialNumber } = Route.useParams()
  const { inquiry: inquiryUid } = Route.useSearch()

  return <TrialDetailPage trialNumber={trialNumber} inquiryUid={inquiryUid} />
}
